import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BulkResumeUploadModule } from 'src/app/shared/bulk-resume-upload/bulk-resume-upload.module';
import { UploadResumesModule } from '../upload-resumes/upload-resumes.module';
import { UnifiedResumeUploadComponent } from './unified-resume-upload.component';

@NgModule({
  declarations: [UnifiedResumeUploadComponent],
  imports: [
    CommonModule,
    FormsModule,
    UploadResumesModule,
    BulkResumeUploadModule
  ],
  exports: [UnifiedResumeUploadComponent],
  entryComponents: [UnifiedResumeUploadComponent]
})
export class UnifiedResumeUploadModule { }
